declare namespace $ {

	export class $mol_icon_robot extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=robot.view.tree.d.ts.map